import { useEffect, useState } from 'react';
import { getTags, TagMetadata } from '../clients/TagsMetadataService';

// TODO(PGD-2055): Remove getSimulatedTags and its usage once MTS provides
// hasBacksidePrinting, hasCampaignCallout, hasGallery and mostPopular metadata tags.
// NOTE: Labels are hardcoded in English; localization is deferred to MTS delivery.
const getSimulatedTags = (): TagMetadata[] => [
  { key: 'HAS_BACKSIDE_PRINTING', label: 'Has Backside Printing' },
  { key: 'HAS_CAMPAIGN_CALLOUT', label: 'Has Campaign Callout' },
  { key: 'HAS_GALLERY', label: 'Has Gallery' },
  { key: 'MOST_POPULAR', label: 'Best Seller' },
];

const mergeWithSimulatedTags = (mtsTags: TagMetadata[]): TagMetadata[] => {
  const mtsKeys = new Set(mtsTags.map((t) => t.key));
  const simulated = getSimulatedTags().filter((t) => !mtsKeys.has(t.key));
  return [...mtsTags, ...simulated];
};

export default function useTags(tenant: string | null, locale: string) {
  const [tags, setTags] = useState<TagMetadata[]>([]);
  const [isLoadingTags, setIsLoadingTags] = useState<boolean>(false);

  const sortByLabelAlphabetic = (a: TagMetadata, b: TagMetadata): number => {
    return a.label.localeCompare(b.label);
  };

  useEffect(() => {
    if (!tenant) return;

    const loadTags = async () => {
      try {
        setIsLoadingTags(true);
        const result = await getTags(tenant, locale);
        if (!result.failed) {
          const merged = mergeWithSimulatedTags(result.result)
            .filter((tag) => tag.label !== '')
            .sort(sortByLabelAlphabetic);
          setTags(merged);
        }
      } catch (error) {
        console.error(
          'Error in useTags: Failed to fetch tags from TagsMetadataService - ',
          error instanceof Error ? error.message : error
        );
      } finally {
        setIsLoadingTags(false);
      }
    };
    loadTags();
  }, [tenant, locale]);

  return { tags, isLoadingTags };
}
